import script from "./7-Sitemap.vue?vue&type=script&setup=true&lang=js"
export * from "./7-Sitemap.vue?vue&type=script&setup=true&lang=js"

import "./7-Sitemap.vue?vue&type=style&index=0&id=e2f01348&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danie\\Documents\\Octave\\production\\marine-debris-2022\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f01348"]])

export default __exports__